import axios from "axios"

const state = {}

const actions = {
    /**
     * 計算をAPIに投げて実行する
     * @param {Object} data 計算用データ 
     */
    //eslint-disable-next-line no-unused-vars
    evaluate({state}, data) {
        return axios.post('/api/eval', data)
    },
    /**
     * PDF出力をAPIに投げて実行する
     * @param {Object} data PDF出力用データ 
     */
    //eslint-disable-next-line no-unused-vars
    exportPdf({state}, data) {
        return axios.post('/api/report', data)
    },
    /**
     * XMLの内容をAPIに投げて取得する
     * @param {Object} fileString XMLの内容部分 
     */
    //eslint-disable-next-line no-unused-vars
    toEditModel({ state }, {fileString, mode}) {
        return axios.post('/api/toeditmodel', { xml: fileString, mode: mode })
    },
    /**
     * 入力データをAPIに投げて保存用XMLを取得する
     * @param {Object} input 入力データ 
     */
    //eslint-disable-next-line no-unused-vars
    exportXml({ state }, input) {
        return axios.post('/api/toxml', input)
    },
}

export default {
    namespaced: true,
    state,
    actions
}